const appKey = process.env.GATSBY_APP
if (!appKey) {
  throw new Error("appKey 不能为空")
}

const title = "BOOOM 2026 游戏创作挑战开启！"
const desc = "不止有 BOOOMJam，还征集移动端游戏啦"

const cdnUrl = "https://site.gcores.com"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: title,
    description: desc,
    shareTitle: title,
    shareDescription: desc,
  },
  data: {
    snapLink: "https://www.qualcomm.cn/",
    gcoresPubLink: "https://site.gcores.com/publishing/",
    enrollLink:
      "https://oi1d3nhtyc6.feishu.cn/share/base/form/shrcndLrsvok49J9RAx3F55Roxe",
    enrollLinkForSeek:
      "https://oi1d3nhtyc6.feishu.cn/share/base/form/shrcnpr1QWV7JjJSegzoc9KBBdd",
    teamGuide: "https://www.gcores.com/articles/196280",
    devQQ: "902382961",
    gameSubmitGuide: "https://www.gcores.com/articles/166349",
  },
}
